(function (){
    'use strict';

    angular
        .module('services')
        .service('RevenueCostBreakdownService', RevenueCostBreakdownService);

    RevenueCostBreakdownService.$inject = ['$http', 'API_BASE'];

    function RevenueCostBreakdownService ($http, API_BASE) {
        var service = this;

        service.getCostFirstLevel = getCostFirstLevel;
        service.getRevenueFirstLevel = getRevenueFirstLevel;
        service.getInvoiceWidget = getInvoiceWidget;
        service.getSecondLevel = getSecondLevel;
        service.getSecondLevelRevenue = getSecondLevelRevenue;
        service.getSecondLevelAdvertising = getSecondLevelAdvertising;
        service.getThirdLevelAdvertising = getThirdLevelAdvertising;
        
        /* Revenue Cost Lead */
        service.getWidgetCostPerRegisteredLead = getWidgetCostPerRegisteredLead;
        service.getWidgetCostPerAcceptedLead = getWidgetCostPerAcceptedLead;
        service.getWidgetCostPerAttendedLead = getWidgetCostPerAttendedLead;

        /* Seller Expenses */
        service.getWidgetSellerExpenses = getWidgetSellerExpenses;

        /* Goals */
        service.getWidgetGoals = getWidgetGoals;

        service.getWidgetSummary = getWidgetSummary;
        

        function getCostFirstLevel(data) {
            return $http.get(API_BASE + '/financial/revenue-cost/list-costs',{params:data});
        }
        function getRevenueFirstLevel(data) {
            return $http.get(API_BASE + '/financial/revenue-cost/list-revenues',{params:data});
        }
        function getInvoiceWidget(data) {
            return $http.get(API_BASE + '/financial/revenue-cost/get-invoice-widget',{params:data});
        }
        function getSecondLevel(data) {
            return $http.get(API_BASE + '/financial/revenue-cost/get-second-level',{params:data});
        }
        function getSecondLevelRevenue(data) {
            return $http.get(API_BASE + '/financial/revenue-cost/get-second-level-revenue',{params:data});
        }
        function getSecondLevelAdvertising(data) {
            return $http.get(API_BASE + '/financial/revenue-cost/get-second-level-advertising',{params:data});
        }
        function getThirdLevelAdvertising(data) {
            return $http.get(API_BASE + '/financial/revenue-cost/get-third-level-advertising',{params:data});
        }

        /* Revenue Cost Lead */
        function getWidgetCostPerRegisteredLead(data) {
            return $http.get(API_BASE + '/financial/revenue-cost/get-cost-registered-widget',{params:data});
        }
        function getWidgetCostPerAcceptedLead(data) {
            return $http.get(API_BASE + '/financial/revenue-cost/get-cost-accepted-widget',{params:data});
        }
        function getWidgetCostPerAttendedLead(data) {
            return $http.get(API_BASE + '/financial/revenue-cost/get-cost-attended-widget',{params:data});
        }

        /* Seller Expenses */
        function getWidgetSellerExpenses(data) {
            return $http.get(API_BASE + '/financial/revenue-cost/get-seller-expenses-widget',{params:data});
        }

        /* Seller Expenses */
        function getWidgetGoals(data) {
            return $http.get(API_BASE + '/financial/revenue-cost/get-goals-widget',{params:data});
        }
        

        function getWidgetSummary(data) {
            return $http.get(API_BASE + '/financial/revenue-cost/get-summary-widget',{params:data});
        }
       
       
    }
})();